import React, {type ReactNode} from 'react';

import {METICULOUS_REDACT_RECORDING} from '../../services/meticulous/privacy';

export {METICULOUS_REDACT_RECORDING};

const displayContents = {display: 'contents'} as const;

export const SensitiveInfoWrapper = ({children}: {children: ReactNode}) => (
  <div
    className={METICULOUS_REDACT_RECORDING}
    data-dd-privacy="mask"
    style={displayContents}>
    {children}
  </div>
);
